// utils.js
export const generateFunctionalUnitId = (name) => {
  return (
    name
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_]/g, "")
    + "_" +
    Date.now()
  );
};
